import {Component, OnInit} from '@angular/core';
import {AdminService} from "../../../../../services/admin.service";
import {SpecializationsService} from "../../services/specializations.service";
import {Router} from '@angular/router';
import {
  AnswerModel,
  QuestionSpecializationModel,
  SpecializationModel,
  BeginnerLevelModel,
  AdvancedLevelModel,
  PositionModel
} from "../../models/learning.model";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SpecWarningComponent} from "../spec-warning/spec-warning.component";
import {HttpStatus, ValidationRules, Language, FileType, LevelNumber, FileIndex, ModalResult, VALIDATION_PATTERN, EXTRA_SPACES_PATTERN} from '../../constants/specializations.constants';

@Component({
  selector: 'app-add-new-specialization',
  templateUrl: './add-new-specialization.component.html',
  styleUrls: ['./add-new-specialization.component.css']
})
export class AddNewSpecializationComponent implements OnInit {

  isSaveBtnDisabled = true;
  operationSuccess = false;
  operationFail = false;
  isErrorOnQuestions = false;
  equalAnswers = false;
  emptyQuestion = false;
  activeTab = 'tab1';
  positionsLoaded = false;
  noPositions = false;
  getPosErr = false;

  id = this.specializationsServ.nodeId;

  specialization: SpecializationModel;
  question: QuestionSpecializationModel;
  answer: AnswerModel;
  beginnerLevels: Array<BeginnerLevelModel>;
  advancedLevels: Array<AdvancedLevelModel>;
  position = PositionModel;

  level_1: BeginnerLevelModel;
  level_2: BeginnerLevelModel;
  level_3: AdvancedLevelModel;
  level_4: AdvancedLevelModel;
  level_5: AdvancedLevelModel;

  formData: FormData = new FormData();
  formData2: FormData = new FormData();
  formDataToSend: FormData = new FormData();
  init = true;
  
  constructor(private adminService: AdminService,
              public specializationsServ: SpecializationsService,
              private router: Router,
              private modalService: NgbModal) {
  }

  ngOnInit() {
    this.initializeSpecialization();
    this.initializeLevels();
    this.validateNodeName();
  }

  private initializeSpecialization() {
    this.specialization = new SpecializationModel(null, null, null, true, true, [], []);
    this.specialization.parentGroup = this.specializationsServ.nodeName;
    this.getPositions();
  }

  private initializeLevels() {
    this.level_1 = new BeginnerLevelModel(null, null, null, 1, "", "", "", "", [this.createQuestionModel()], [this.createQuestionModel()]);
    this.level_2 = new BeginnerLevelModel(null, null, null, 2, "", "", "", "", [this.createQuestionModel()], [this.createQuestionModel()]);
  }

  private validateNodeName() {
    if (this.specializationsServ.nodeName === '') {
      this.router.navigateByUrl('/dashboard/specializations-list');
    }
  }

  checkLength(data) {
    if (data.length === 0 || !this.checkRequirementsLength()) {
      this.init = false;
    } else {
      this.init = true;
    }
  }

  preventExtraSpaces(event: KeyboardEvent) {
    const textarea = event.target as HTMLTextAreaElement;
    const currentValue = textarea.value;
    const key = event.key;
  
    if (key === ' ' && currentValue.match(EXTRA_SPACES_PATTERN)) {
      event.preventDefault();
    }
  }
  
  checkRequirementsLength() {
    if (this.hasAllLevelsValid()) return true;
    if (this.hasTwoLevelsValid()) return true;
    if (this.hasOneLevelValid()) return true;
    return false;
  }

  private hasAllLevelsValid() {
    return this.level_3 && this.level_4 && this.level_5 &&
      this.level_3.ruRequirements && this.level_4.ruRequirements && this.level_5.ruRequirements &&
      this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH &&
      this.level_4.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH &&
      this.level_5.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH;
  }

  private hasTwoLevelsValid() {
    return this.level_3 && this.level_4 &&
      this.level_3.ruRequirements && this.level_4.ruRequirements &&
      this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH &&
      this.level_4.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH;
  }

  private hasOneLevelValid() {
    return this.level_3 &&
      this.level_3.ruRequirements &&
      this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH;
  }

  add() {
    switch (true) {
      case !this.level_3:
        this.level_3 = new AdvancedLevelModel(null, 3, "", "");
        this.init = false;
        break
      case !this.level_4:
        if (this.level_3.ruRequirements && this.level_3.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH) {
          this.level_4 = new AdvancedLevelModel(null, 4, "", "");
          this.init = false;
        }
        break
      case !this.level_5:
        if (this.level_4.ruRequirements && this.level_4.ruRequirements.length >= ValidationRules.MIN_REQUIREMENTS_LENGTH) {
          this.level_5 = new AdvancedLevelModel(null, 5, "", "");
          this.init = false;
        }
        break
      default:
    }
  }

  del() {
    switch (true) {
      case this.level_5 != null:
        delete this.level_5;
        this.init = true;
        break;
      case this.level_4 != null:
        delete this.level_4;
        this.init = true;
        break;
      case this.level_3 != null:
        delete this.level_3;
        this.init = true;
        break;
      default:
        break;
    }
  }

  closeAlert() {
    this.operationSuccess = false;
    this.operationFail = false;
    this.equalAnswers = false;
    this.emptyQuestion = false;
    this.isErrorOnQuestions = false;
  }

  checkSpecName(value) {
    this.specialization.name = value;
    const nameInvalid = !value || 
      value.trim() === '' || 
      value.trim().length < ValidationRules.MIN_NAME_LENGTH || 
      value.startsWith(' ') || 
      value.endsWith(' ') || 
      !VALIDATION_PATTERN.test(value);
    
    const questionsInvalid = this.hasInvalidCharacters(this.level_1.ruQuestions) || 
                             this.hasInvalidCharacters(this.level_2.ruQuestions);
    
    this.isSaveBtnDisabled = nameInvalid || questionsInvalid;
  }

  // Enable/disable specialization for learning
  // switchCheckBox() {
  //   if (!this.specialization.level1) {
  //     this.specialization.level2 = false;
  //   }
  // }

  setActiveLevel(event) {
    this.activeTab = event.nextId;
  }

  getPositions() {
    this.adminService.getActivePositions().subscribe(
      (res: any) => this.handleGetPositionsSuccess(res),
      (err) => this.handleGetPositionsError(err)
    );
  }

  private handleGetPositionsSuccess(res: any) {
    if (res.status === HttpStatus.OK) {
      this.specializationsServ.positions = res.body;
      this.selectPosition(this.specializationsServ.positions[0]);
      this.positionsLoaded = true;
    } else if (res.status === HttpStatus.NO_CONTENT) {
      this.positionsLoaded = true;
      this.noPositions = true;
    }
  }

  private handleGetPositionsError(err) {
    if (err.status === HttpStatus.INTERNAL_SERVER_ERROR || err.status === HttpStatus.NOT_IMPLEMENTED || err.status === HttpStatus.BAD_GATEWAY) {
      this.positionsLoaded = true;
      this.getPosErr = true;
    }
  }

  selectPosition(position) {
    this.specializationsServ.selectedPositionId = position.id;
    this.specializationsServ.selectedPositionName = position.name;
    this.specialization.position = position;
  }

  private createQuestionModel() {
    return {
      questionText: "",
      answers: [{answerText: ""}, {answerText: ""}, {answerText: ""}],
      rightAnswer: {answerText: ""}
    };
  }

  addQuestion(level) {
    switch (level) {
      case 1:
        this.level_1.enQuestions.push(this.createQuestionModel());
        this.level_1.ruQuestions.push(this.createQuestionModel());
        break;
      case 2:
        this.level_2.enQuestions.push(this.createQuestionModel());
        this.level_2.ruQuestions.push(this.createQuestionModel());
        break;
    }
  }

  removeQuestion(level) {
    switch (level) {
      case 1:
        this.level_1.enQuestions.splice(-1, 1);
        this.level_1.ruQuestions.splice(-1, 1);
        break;
      case 2:
        this.level_2.enQuestions.splice(-1, 1);
        this.level_2.ruQuestions.splice(-1, 1);
        break;
    }
  }

  setRightAnswer(lvl: number, lang: string, i, k) {
    const level = lvl === LevelNumber.LEVEL_1 ? this.level_1 : this.level_2;
    const questions = lang === Language.RU ? level.ruQuestions : level.enQuestions;
    questions[i].rightAnswer = questions[i].answers[k];
  }

  handleFileInput(type: string, event) {
    const files = event.target.files;
    if (files.length) {
      const file: File = files[0];
      this.formData.set(type, file, file.name);
    } else {
      this.formData.delete(type);
    }
  }

  handleFileInput2(type: string, event) {
    const files = event.target.files;
    if (files.length) {
      const file: File = files[0];
      this.formData2.set(type, file, file.name);
    } else {
      this.formData2.delete(type);
    }
  }

  uploadFile(lvl_id, lvl_number) {
    if (lvl_number === FileIndex.FIRST) {
      this.formDataToSend = this.formData;
    }
    if (lvl_number === FileIndex.SECOND) {
      this.formDataToSend = this.formData2;
    }

    this.adminService.uploadSpecFile(this.formDataToSend, lvl_id).subscribe(
      (res: any) => {
      },
      () => {
        this.specializationsServ.fileUploadFailed = true;
      }
    );
  }

  open() {
    const modalRef = this.modalService.open(SpecWarningComponent);
    modalRef.result.then((result) => {
      if (result === ModalResult.OK) {
        this.createSpecAPI();
      }
    });
  }

  setErrorState(emptyQuestion: boolean, equalAnswers: boolean) {
    this.emptyQuestion = emptyQuestion;
    this.equalAnswers = equalAnswers;
  }

  hasEmptyQuestions(questions: QuestionSpecializationModel[]) {
    return questions.some(q => {
      if (!q.questionText || q.questionText.trim() === '') return true;
      if (!q.rightAnswer.answerText || q.rightAnswer.answerText.trim() === '') return true;
      return q.answers.some(a => !a.answerText || a.answerText.trim() === '');
    });
  }

  hasInvalidCharacters(questions: QuestionSpecializationModel[]) {
    return questions.some(q => {
      if (q.questionText && q.questionText.trim() && !VALIDATION_PATTERN.test(q.questionText)) return true;
      if (q.rightAnswer.answerText && q.rightAnswer.answerText.trim() && !VALIDATION_PATTERN.test(q.rightAnswer.answerText)) return true;
      return q.answers.some(a => a.answerText && a.answerText.trim() && !VALIDATION_PATTERN.test(a.answerText));
    });
  }

  checkQuestionsValidity() {
    const nameInvalid = !this.specialization.name || 
      this.specialization.name.trim() === '' || 
      this.specialization.name.trim().length < ValidationRules.MIN_NAME_LENGTH || 
      this.specialization.name.startsWith(' ') || 
      this.specialization.name.endsWith(' ') || 
      !VALIDATION_PATTERN.test(this.specialization.name);
    
    const questionsInvalid = this.hasInvalidCharacters(this.level_1.ruQuestions) || 
                             this.hasInvalidCharacters(this.level_2.ruQuestions);
    
    this.isSaveBtnDisabled = nameInvalid || questionsInvalid;
  }

  checkEquals (questions: QuestionSpecializationModel[]) {
    for (const question of questions) {
      const answers = question.answers.map(a => a.answerText.trim()).filter(a => a.length);
      const uniqueAnswers = new Set(answers);
      
      if (answers.length && uniqueAnswers.size < answers.length) {
        return false;
      }
    }
    return true;
  }

  createSpec() {
    if (this.hasEmptyQuestions(this.level_1.ruQuestions) ||
      this.hasEmptyQuestions(this.level_2.ruQuestions)
    ) {
      this.setErrorState(true, false);
      return;
    }

    if (!this.checkEquals(this.level_1.ruQuestions) ||
      !this.checkEquals(this.level_2.ruQuestions)
    ) {
      this.setErrorState(false, true);
      return;
    }

    this.setErrorState(false, false);

    const level1HasEmptyFields = !this.level_1.ruYoutubeLink || !this.level_1.ruRequirements || !this.formData.has('RU_PPT');
    const level2HasEmptyFields = !this.level_2.ruYoutubeLink || !this.level_2.ruRequirements || !this.formData2.has('RU_PPT');
    const hasEmptyOptionalFields = level1HasEmptyFields || level2HasEmptyFields;

    if (hasEmptyOptionalFields) {
      this.isErrorOnQuestions = true;
      if (this.specializationsServ.isOperationAccepted === false) {
        this.open();
      } else {
        this.createSpecAPI();
      }

    } else {
      this.isErrorOnQuestions = false;
      this.createSpecAPI();
    }
  }

  createSpecAPI() {
    this.buildSpecializationLevels();
    this.adminService.createSpec(this.specialization, this.id).subscribe(
      (res: any) => this.handleCreateSuccess(res),
      () => this.handleCreateError()
    );
  }

  private buildSpecializationLevels() {
    this.specialization.beginnerLevels.push(this.level_1, this.level_2);
    if (this.level_3) this.specialization.advancedLevels.push(this.level_3);
    if (this.level_4) this.specialization.advancedLevels.push(this.level_4);
    if (this.level_5) this.specialization.advancedLevels.push(this.level_5);
  }

  private handleCreateSuccess(res: any) {
    this.specialization = res.body;
    this.specializationsServ.updateTree();
    this.operationSuccess = true;
    this.operationFail = false;
    this.uploadFiles();
    this.finishCreation();
  }

  private uploadFiles() {
    this.uploadFile(this.specialization.beginnerLevels[0].id, FileIndex.FIRST);
    this.uploadFile(this.specialization.beginnerLevels[1].id, FileIndex.SECOND);
  }

  private finishCreation() {
    this.specializationsServ.createSpecSuccess = true;
    this.specializationsServ.isOperationAccepted = false;
    this.router.navigateByUrl('/dashboard/specializations-list');
  }

  private handleCreateError() {
    this.operationFail = true;
    this.specializationsServ.isOperationAccepted = false;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/specializations/components/add-new-specialization/add-new-specialization.component.ts